import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {
  @Input() isShowRole:boolean  =false;
  basicInfo: any = {}; //用户基本信息
  isMobile:boolean = false;
  img:string = "";
  isInquiry:boolean = true;
  
  // Token display properties
  tokenInfo: any = {
    accessToken: null,
    idToken: null,
    account: null,
    tokenExpiry: null
  };
  showTokens: boolean = false;
  constructor(private authService: AuthService,private commonService: CommonService, private router:Router) { }
  ngOnInit(): void {
    console.log('👤 UserInfoComponent ngOnInit called');
    this.isMobile = this.commonService.IsMobile();

    // Check if user is actually authenticated before making API calls
    const isAuthenticated = this.authService.isAuthenticated();
    if (!isAuthenticated) {
      console.log('👤 User not authenticated, skipping API calls in UserInfoComponent');
      return;
    }

    this.authService.msalAccountInfo$$
    // after login then call api, otherwise cause looping on login page
      .subscribe((accountInfo) => {
        console.log('👤 UserInfoComponent accountInfo changed:', accountInfo);
        if(accountInfo){
          // Load token information for debugging
          this.loadTokenInfo();
          
          // Only make API calls if we have a valid authenticated account
          this.authService.getBasicInfo().subscribe((res) => {
            console.log('👤 UserInfoComponent getBasicInfo success:', res);
            this.basicInfo = res;
            // COMMENTED OUT: GetUserPhoto functionality not needed
           /*
           //獲取頭像 - Use multiple fallback options for user ID
           const userId = this.basicInfo?.id ||
                         this.basicInfo?.staffID ||
                         this.basicInfo?.userOid ||
                         this.basicInfo?.oid ||
                         this.basicInfo?.objectId ||
                         accountInfo?.localAccountId ||
                         accountInfo?.homeAccountId?.split('.')[0]; // Extract OID from homeAccountId

           console.log('🖼️ Getting user photo for userId:', userId);
           console.log('🔍 Available user info:', {
             basicInfoId: this.basicInfo?.id,
             staffID: this.basicInfo?.staffID,
             userOid: this.basicInfo?.userOid,
             oid: this.basicInfo?.oid,
             objectId: this.basicInfo?.objectId,
             localAccountId: accountInfo?.localAccountId,
             homeAccountId: accountInfo?.homeAccountId,
             username: accountInfo?.username
           });

           if (userId && userId !== 'null' && userId !== 'undefined') {
             this.authService.getUserImg(userId).subscribe({
               next: (result) => {
                 console.log('✅ User photo result:', result);
                 this.img = result?.data?.photoUrl || '';
               },
               error: (error) => {
                 console.error('❌ User photo error:', error);
                 this.img = error?.error?.text || '';
               },
             });
           } else {
             console.warn('⚠️ No valid user ID found for photo, using default avatar');
             this.img = '';
           }
           */

           // Use default avatar instead
           console.log('ℹ️ Using default avatar (GetUserPhoto disabled)');
           this.img = '';
           // Use userPrincipalName directly without double encoding, or fall back to email
           let userAD = this.basicInfo?.userPrincipalName || this.basicInfo?.email;
           console.log('🔍 Getting support team for userAD:', userAD);
           
            //判断当前用户是否为Support Team 人员
            if (userAD) {
              this.authService.getSupportTeamByUser(userAD).subscribe({
              next: (user) => {
                localStorage.setItem('isSupport', user && user.length > 0 ? "true" : "false");
                this.basicInfo.supportTeam = user;
                localStorage.setItem('User', JSON.stringify(this.basicInfo));
              },
              error: () => { 
                localStorage.setItem('isSupport', "false");
                localStorage.setItem('User', JSON.stringify(this.basicInfo));
              },
            });
            } else {
              console.warn('⚠️ No userAD found, skipping support team check');
              localStorage.setItem('isSupport', "false");
              localStorage.setItem('User', JSON.stringify(this.basicInfo));
            }
          })
        }
      })
    if(!window.location.hash.includes("/inquiry")){
      this.isInquiry = false;
    }
  }
  logout(){
    this.authService.logout()
  }
  gotoAdminPage(){
    this.isInquiry = false;
    this.router.navigate(['/category']);
  }
  backtoInquiry(){
    this.isInquiry = true;
    this.router.navigate(['/inquiry']);
  }
  gotoSubCategoyPage(){
    this.router.navigate(['/subcategory']);
  }
  gotoSupportTeamPage(){
    this.router.navigate(['/support']);
  }
  
  // Load current token information
  loadTokenInfo() {
    console.log('🔐 Loading token information...');
    this.authService.getCurrentTokens().subscribe({
      next: (tokens) => {
        console.log('🎯 Token information loaded:', {
          hasAccessToken: !!tokens.accessToken,
          hasIdToken: !!tokens.idToken,
          account: tokens.account?.username,
          expiry: tokens.tokenExpiry
        });
        this.tokenInfo = tokens;
      },
      error: (error) => {
        console.error('❌ Failed to load token information:', error);
        this.tokenInfo = {
          accessToken: null,
          idToken: null,
          account: null,
          tokenExpiry: null
        };
      }
    });
  }
  
  // Toggle token display
  toggleTokenDisplay() {
    this.showTokens = !this.showTokens;
    console.log('🔄 Token display toggled:', this.showTokens);
    
    // Refresh token info when showing
    if (this.showTokens) {
      this.loadTokenInfo();
    }
  }
  
  // Copy token to clipboard
  copyTokenToClipboard(tokenType: string) {
    let tokenValue = '';
    
    if (tokenType === 'access' && this.tokenInfo.accessToken) {
      tokenValue = this.tokenInfo.accessToken;
    } else if (tokenType === 'id' && this.tokenInfo.idToken) {
      tokenValue = this.tokenInfo.idToken;
    }
    
    if (tokenValue) {
      navigator.clipboard.writeText(tokenValue).then(() => {
        console.log(`✅ ${tokenType} token copied to clipboard`);
        // You could add a toast notification here
      }).catch(err => {
        console.error('❌ Failed to copy token:', err);
      });
    }
  }
  
  // Get truncated token for display
  getTruncatedToken(token: string | null, maxLength: number = 50): string {
    if (!token) return 'Not available';
    if (token.length <= maxLength) return token;
    return token.substring(0, maxLength) + '...';
  }
  
  // Manual authentication reset for stuck sessions
  resetAuthentication() {
    console.log('🔄 Manual authentication reset triggered');
    
    // Clear authentication state and force fresh login
    this.authService.emergencyAuthReset();
    
    // Refresh the page after a short delay to ensure clean state
    setTimeout(() => {
      console.log('🔄 Refreshing page for clean authentication state...');
      window.location.reload();
    }, 2000);
  }
}
